import { Component } from 'react';
import { setMark } from '@atlassian/jira-common-performance';

type Props = {
	baseUrl: string;
	context: string | undefined;
	onLoadEnd: (arg1: string) => void;
};

/**
 * Use this component for storybooks or other test components that don't want to be connected to the
 * "real" servicedesk-frontend-apdex library.
 */
// eslint-disable-next-line jira/react/no-class-components
export default class ReadyForUser extends Component<Props> {
	static defaultProps = {
		baseUrl: 'localhost:2990/jira',
		context: undefined,
	};

	componentDidMount() {
		this.recordEndMetric();
	}

	componentDidUpdate(prevProps: Props) {
		if (prevProps.context !== this.props.context) {
			this.recordEndMetric();
		}
	}

	recordEndMetric() {
		const { baseUrl, onLoadEnd } = this.props;
		const location = window.location.pathname.replace(baseUrl, '');
		setMark('jsd.performance.profile.record.metric.end');
		onLoadEnd(location);

		// Unfortunately the apdex key for this legacy apdex mark is calculated outside of the jira-frontend
		// in cypress 'location' ends up being 'iframe.html' so we can't actually check if the correct metric key is being triggered
		// we can at least check if it has been triggered at all
		if (process.env.NODE_ENV !== 'production') {
			// eslint-disable-next-line jira/import/webpack-magic-comment-entries
			import('@atlassian/jira-common-integration-tests/src/signal/emit').then(({ emitSignal }) =>
				emitSignal('apdex.submited'),
			);
		}
	}

	render() {
		return null;
	}
}
